var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.383,167.424C78.383,167.424 87.295,118.196 87.013,84.811C87.013,84.811 143.558,86.161 219.19,86.321C259.682,86.407 305.645,86.151 351.331,85.165C351.331,85.165 350.615,123.005 356.274,167.035C356.274,167.035 343.365,172.87 327.274,171.986C327.274,171.986 328.866,111.335 275.995,110.274L246.289,110.384L246.387,366.941C246.387,366.941 245.424,404.093 284.831,401.577C288.235,401.36 289.974,412.883 289.974,424.972C289.974,424.972 213.445,422.34 146.023,424.943C146.023,424.943 146.276,401.517 151.143,401.404C156.009,401.291 190.525,404.347 190.865,364.285C191.204,324.224 191.045,110.642 191.045,110.642L158.379,110.438C158.379,110.438 113.395,108.454 107.454,171.974C107.454,171.974 86.138,171.891 78.397,167.348",
    style: {
      stroke: "black",
      strokeWidth: 1
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45142,0,0,1.45142,-217.957,-135.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 421.98,
    cy: 364.211,
    r: 27.488
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.44f38c3f.svg";
export { ForwardRef as ReactComponent };